import React from 'react';

function EventSelector({
    events,
    selectedEventId,
    onSelectEvent,
    selectedEvent,
    saving,
    onRegistrationToggle,
    onEditEvent
}) {
    const isPublished = selectedEvent?.status === 'published';

    return (
        <>
            <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
                <select
                    value={selectedEventId}
                    onChange={(e) => onSelectEvent(e.target.value)}
                    className="admin-form-input"
                >
                    <option value="">Select event</option>
                    {events.map((event) => (
                        <option key={event._id} value={event._id}>
                            {event.title} ({event.status})
                        </option>
                    ))}
                </select>
            </div>

            {selectedEvent && (
                <div className="action-row" style={{ marginBottom: '1rem' }}>
                    <div className="cta-text" style={{ width: '100%' }}>
                        <p>Selected Event</p>

                        <div style={{ fontWeight: 'bold', fontSize: '1.05rem', marginTop: '0.6rem' }}>
                            {selectedEvent.title}
                        </div>

                        <div style={{ color: '#999', marginTop: '0.5rem', fontSize: '0.92rem' }}>
                            Status: {selectedEvent.status}
                        </div>

                        <div style={{ color: '#999', marginTop: '0.35rem', fontSize: '0.92rem' }}>
                            Venue: {selectedEvent.venue?.name || 'Venue TBA'}
                        </div>

                        <div style={{ color: '#999', marginTop: '0.35rem', fontSize: '0.92rem' }}>
                            Address: {selectedEvent.venue?.address || 'Address TBA'}
                        </div>

                        <div style={{ color: '#999', marginTop: '0.35rem', fontSize: '0.92rem' }}>
                            Capacity: {selectedEvent.capacity}
                        </div>

                        <div style={{ color: '#999', marginTop: '0.35rem', fontSize: '0.92rem' }}>
                            Slug: {selectedEvent.slug}
                        </div>

                        <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                            <button
                                type="button"
                                onClick={onRegistrationToggle}
                                disabled={saving}
                            >
                                {isPublished ? 'Close Registration' : 'Reopen Registration'}
                            </button>

                            <button
                                type="button"
                                onClick={onEditEvent}
                                disabled={saving}
                                className="refresh-btn"
                            >
                                Edit Event
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EventSelector;